import PSY_URI from '@/assets/Utils/api/url-const'
import { GET ,POST } from '@/assets/Utils/api/http';

/*
* 员工活动列表
* @parmm{}
* */
export const GetStaffActivities = ()=>{
  return GET(PSY_URI.STAFF_ACTIVITIES)
}
/*
* 办公环境列表
* @parmm{}
* */
export const GetOfficeEnvironment =()=>{
  return GET(PSY_URI.OFFICE_ENVIRONMENT)
}
